/**
 * Route for `cohort-analysis`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CohortAnalysisPage } from "../features/cohort-analysis/CohortAnalysisPage";

export const cohortAnalysisRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/cohort-analysis",
	component: CohortAnalysisPage,
});

export default cohortAnalysisRoute;
